import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIf, NgForOf } from '@angular/common';
import { CreateGolfEventRequest } from '../../../models/creategolfeventrequest';
import { GolfEventService } from '../../../services/golf-event.service';
import { PlayerService } from '../../../services/player.service';
import { Player } from '../../../models/Player';
import { SelectablePlayer } from '../../../models/viewmodels/selectableplayer';
import { ApplicationService } from '../../../services/application.service';

@Component({
  selector: 'app-create-event',
  standalone: true,
  imports: [FormsModule, NgIf, NgForOf],
  templateUrl: './create-event.component.html',
  styleUrl: './create-event.component.css'
})
export class CreateEventComponent implements OnInit {

  constructor(private golfEventService:GolfEventService, private playerService:PlayerService, private applicationService:ApplicationService) {}

  @Output() saved = new EventEmitter<number>();

  createGolfEventRequest:CreateGolfEventRequest = {
    description: '',
    endDate: new Date(),
    entryFee: 0,
    eventName: '',
    firstPlacePrizeMoney: 0,
    secondPlacePrizeMoney: 0,
    startDate: new Date(),
    thirdPlacePrizeMoney: 0,
    type: 'LEAGUE',
    playerIds: []
  }

  currentStep:string = 'EVENTINFO'
  field:Array<SelectablePlayer> = [];

  ngOnInit(): void {
   this.getPlayers(); 
  }

  moveToStep(stepName:string):void {
    this.currentStep = stepName;
  }

  async getPlayers():Promise<void> {
    let players:Array<Player> = await this.playerService.searchPlayers();
    players.forEach(p => {
      this.field.push({ isSelected:false, player: p });
    });
  }

  getFinalField():Array<SelectablePlayer> {
    return this.field.filter(f => f.isSelected);
  }

  async save() {
    let includedPlayers = this.getFinalField();
    this.createGolfEventRequest.playerIds = includedPlayers.map(p => p.player.id);
    this.applicationService.showGlobalSpinner();
    let eventId = await this.golfEventService.createEvent(this.createGolfEventRequest);
    this.applicationService.hideGlobalSpinner();
    this.saved.emit(eventId);
  }
}